export const invertedMessages = {
  "Couldn't Load": 'COULD_NOT_LOAD.ATTESTATIONS',
  Refresh: 'Refresh.ATTESTATIONS',
  Close: 'CloseLabel',
  "The Summary tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_SUMMARY',
  "The History tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_HISTORY',
  "The Progress tab didn't load properly due to a network issue. Please refresh or try again later.":
    'CERTS_SIDEPANEL_TAB_PROGRESS',
  Cancelled: 'CancelledCertification.Default.label',
  Completed: 'Completed.Certification.label',
  Reassigned: 'Reassigned.v2.label.ATTESTATIONS',
  Exported: 'Exported.Certification.label',
  'This certification in classic experience':
    'CERTS_CLASSIC_EXPERIENCE_MESSAGE',
  'Viewing unavailable — Classic Experience Campaign':
    'certs.classic.campaign.alert.title',
  'This certification was launched in the classic experience. Detailed view cannot be displayed, but your campaign data is preserved and available to download.':
    'certs.classic.campaign.alert.subtitle',
};
